'use strict';
import BusinessYourDetails from './BusinessYourDetails.jsx';
var React = require('react');
var YourDetailsStore = require('../../stores/YourDetailsStore');
//Constants
var ApplicationConstants = require('../../constants/ApplicationConstants');
var ProductIds = ApplicationConstants.ProductIds;
var AccountTypeCodes = ApplicationConstants.AccountTypeCodes;
var FormKeys = ApplicationConstants.FormKeys;
//Components
var SectionHeader = require('../Common/SectionHeader.jsx');
var InvestorsSection = require('./InvestorsSection.jsx');
var Individual = require('./Individual.jsx');
var YourDetails = {};
var TrusteeSections = {};

// Your Details for personal
YourDetails[ProductIds.SUPER] = require('./SuperAnnuation.jsx');
YourDetails[ProductIds.PENSION] = require('./Pension.jsx');
YourDetails[FormKeys.INDIVIDUAL_INVESTMENT] = Individual;
YourDetails[FormKeys.INDIVIDUAL_COMMINSURE] = Individual;
YourDetails[FormKeys.INDIVIDUAL_CHALLENGER] = Individual;
YourDetails[FormKeys.JOINT_INVESTMENT] = InvestorsSection;
YourDetails[FormKeys.JOINT_COMMINSURE] = InvestorsSection;
YourDetails[FormKeys.JOINT_CHALLENGER] = InvestorsSection;
YourDetails[FormKeys.SOLE_TRADER_INVESTMENT] = require('./SoleTraderInvestment.jsx');

//Your Details for business
YourDetails[FormKeys.PARTNERSHIP_INVESTMENT] = BusinessYourDetails;
YourDetails[FormKeys.COMPANY_INVESTMENT] = BusinessYourDetails;
YourDetails[FormKeys.COMPANY_COMMINSURE] =  BusinessYourDetails;
YourDetails[FormKeys.COMPANY_CHALLENGER] =  BusinessYourDetails;
YourDetails[FormKeys.SMSF_INVESTMENT] =  BusinessYourDetails;
YourDetails[FormKeys.SMSF_COMMINSURE] =  BusinessYourDetails;
YourDetails[FormKeys.SMSF_CHALLENGER] =  BusinessYourDetails;
YourDetails[FormKeys.TRUST_INVESTMENT] =  BusinessYourDetails;
YourDetails[FormKeys.TRUST_COMMINSURE] =  BusinessYourDetails;
YourDetails[FormKeys.TRUST_CHALLENGER] =  BusinessYourDetails;

//Sub-secton - investor or trustee list
TrusteeSections[FormKeys.COMPANY_INVESTMENT] = InvestorsSection;
TrusteeSections[FormKeys.PARTNERSHIP_INVESTMENT] = InvestorsSection;
TrusteeSections[FormKeys.SMSF_INVESTMENT] = InvestorsSection;
TrusteeSections[FormKeys.SMSF_COMMINSURE] = InvestorsSection;
TrusteeSections[FormKeys.SMSF_CHALLENGER] = InvestorsSection;
TrusteeSections[FormKeys.TRUST_INVESTMENT] = InvestorsSection;
TrusteeSections[FormKeys.TRUST_COMMINSURE] = InvestorsSection;
TrusteeSections[FormKeys.TRUST_CHALLENGER] = InvestorsSection;

var YourDetailsSection = React.createClass({
    getInitialState: function () {
        return {
            formKey: YourDetailsStore.getFormKey()
        };
    },
    componentDidMount: function () {
        YourDetailsStore.addChangeListener(this._onChange);
    },
    componentWillUnmount: function () {
        YourDetailsStore.removeChangeListener(this._onChange);
    },
    _onChange: function () {
        this.setState({ formKey: YourDetailsStore.getFormKey() });
    },
    render: function () {
        var YourDetailsSubComponent = YourDetails[this.state.formKey] || 'div';

        var TrusteeOrInvestmentComponent = TrusteeSections[this.state.formKey] || 'div';

        var sectionHelp = (this.props.accountType === AccountTypeCodes.JOINT) ? this.props.content.yourDetails.sectionHelpJointCopy : this.props.content.yourDetails.sectionHelpCopy;
        return (
            <div id="your-details-section" className="form-step">
                <div className="form-sub-section">
                    <SectionHeader sectionName={this.props.content.yourDetails.sectionHeader}
                                   sectionHelpText={this.props.content.common.sectionHeaderHelp}
                                   NeedHelpInfo={sectionHelp}
                                   focus={this.props.focus} />
                    <div className="container">
                        <YourDetailsSubComponent productId={this.props.productId} accountType={this.props.accountType} formKey={this.state.formKey} content={this.props.content} />
                        <TrusteeOrInvestmentComponent productId={this.props.productId} accountType={this.props.accountType} formKey={this.state.formKey}  content={this.props.content}/>
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = YourDetailsSection;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/YourDetailsSection.jsx